import { Injectable, } from '@angular/core';
import {Observable, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class LoaderProvider {
  private isLoadingValue = new Subject();

  constructor() { }

  getIsLoadingValue(): Observable<any> {
    return this.isLoadingValue;
  }

  updateLoadingValue(value: boolean) {
    this.isLoadingValue.next(value);
  }
}
